<template>
  <section>
    <Fieldset
      :legend="translate('additional informations', 'ucfirst')"
    class="relative w-full px-5 pb-4 mt-5 uppercase bg-white rounded-lg shadow-md border border-color-iron"
    >
      <Skeleton v-if="isLoading && additionalInfo" height="1.5rem"></Skeleton>
      <ul
        v-else-if="!isLoading && additionalInfo.length > 0"
        class="list-inside list-disc"
      > 
        <li v-for="(information, index) in additionalInfo" :key="index" class="mt-3">
         <a v-if="isValidUrl(information.value)" :href="information.value" target="_blank" class="hover:underline">{{getAddInfoNameLink(information.type)}}</a> 
          <span v-else>{{information.value}}</span> 
        <i @click="showModal('update','additional informations',information)" class="pi pi-pencil cursor-pointer ml-2 text-base"></i>
        </li> 

        <i @click="showModal('create','additional informations')" class="pi pi-plus cursor-pointer absolute -top-3 right-2 text-lg"></i>
      </ul>
      <ul v-else>
        <li>{{ translate("no additional information", "ucfirst") }}</li>
        <i @click="showModal('create','additional informations')" class="pi pi-plus cursor-pointer absolute top-1 right-5 text-lg"></i>
      </ul>
    </Fieldset>

    <ModalDialogComponent :isvisible="visible" @close-modal="closeModalDialog">
      <template #title>
        {{ displayModalTitle }}
      </template>
      <template #content>
        <ProfessionalAdditionalInfoForm
          :addinfo-to-update="addInfoToUpdate" :curriculum-id="props.addInformation.curriculum.id" 
          @addinformation-updated="updateAddinformation"
          @close-modal="closeModalDialog"
        />
      </template>
    </ModalDialogComponent>
  </section>
</template>

<script setup>
import { ref, onMounted, onUpdated } from "vue";
import Fieldset from "primevue/fieldset";
import Skeleton from "primevue/skeleton";
import { translate } from "@/composables/translate";
import requestHandler from "@/composables/requestHandler";
import useModalCurriculum from "@/composables/modalDialogCurriculum";
import ModalDialogComponent from "@/components/Utils/ModalDialogComponent.vue";
import ProfessionalAdditionalInfoForm from "@/components/Dashboard/Applicant/FormsCurriculum/ProfessionalAdditionalInfoForm.vue";

const props = defineProps({
  addInformation: {
    type: Array,
    required: true,
    default: ()=> []
  }
});

let additionalInfo = ref([]);
let isLoading = ref(false);
let visible = ref(false)  
let addInfoToUpdate = ref({})  

let { toggleCreateUpdateTitle, displayModalTitle } = useModalCurriculum();

// Tipos de informação que requerem um link
let addInfoLinks = [
  {id: 1, name: 'portfolio'},
  {id: 2, name: 'github'},
  {id: 3, name: 'linkedin'},
  {id: 4, name: 'website'},
  {id: 5, name: 'blog'}
]

// ############ Criação de Métodos/Funções ############

function showModal(type, title, information={}) {
  toggleCreateUpdateTitle(type,title)
  addInfoToUpdate.value = information
  visible.value = true
}

function closeModalDialog(event){  
  visible.value = event
}

async function updateAddinformation(){  

  isLoading.value = true
  const response = await requestHandler.executeRequest("/api/curriculum",{},"get");
  if (response.success) additionalInfo.value = response.data.additional_information;
  
  isLoading.value = false
}

function isValidUrl(string) {
  try {
    new URL(string);
    return true;
  } catch (err) {
    return false;
  }
}

function getAddInfoNameLink(item) {
  for (let i = 0; i < addInfoLinks.length; i++) {
    const type = addInfoLinks[i];
    if (type.id == item) {
      return type.name
    } 
  }
}

onUpdated(() => {
  isLoading.value = false
  if (props.addInformation.addinfo.length > 0 ) additionalInfo.value = props.addInformation.addinfo
})

onMounted(() => {
  isLoading.value = true
});
</script>